import script from "./WCAddToListModernCardButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WCAddToListModernCardButton.vue?vue&type=script&setup=true&lang=js"

import "./WCAddToListModernCardButton.vue?vue&type=style&index=0&id=9b727d8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b727d8e"]])

export default __exports__